const FontFaceObserver = require('fontfaceobserver');

/**
 * Uses FontFaceObserver to load fonts and retuns a Promise
 * that resolves when all are loaded.
 * @return {Promise}
 */
function load(fonts: string[]): Promise<void> {
  const loaders = fonts.map((font) => new FontFaceObserver(font).load());
  return Promise.all(loaders).then(() => {
    document.body.className += ' fonts-loaded';
  });
}

export default { load };



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/lib/load_fonts.ts